import React from "react";

interface CardGradientProps {
  className?: string;
  width?: string | number;
  height?: string | number;
}

const TokenIcon: React.FC<CardGradientProps> = ({
  className,
  width = "20",
  height = "13",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="6.48837"
        cy="6.5"
        r="4.98837"
        stroke="#CFB2FF"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.0116 11.4884C15.7666 11.4884 18 9.255 18 6.5C18 3.745 15.7666 1.51163 13.0116 1.51163"
        stroke="#FFA686"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default TokenIcon;
